import React, {useEffect, useState} from 'react';
import '../../css/gardenPlanterStylings/PlotPlanterGardenVeggiesStyling.css';
// import veggies from '../../data/veggies.json';
import fallbackImage from '../../images/fallback/plantFallbackImage.png'
import { supabase } from '../lib/supabaseClient';

const PlotPlanterGardenVeggies = ({ selectedVeggies, veggieCounts, onVeggieDragStart }) => {
    const [inputWidth, setInputWidth] = useState(25);
    const [inputHeight, setInputHeight] = useState(25);
    const [dimensionsByVeggie, setDimensionsByVeggie] = useState({});

    // pulling plant images from db
    const [veggies, setVeggies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchVeggies = async () => {
            // console.log("Fetching plant data");
            const { data, error } = await supabase
                .from('plant')
                .select('*')
                .order('plant_name', { ascending: true });

            if (error) {
                console.error('Error fetching plants:', error);
            } else {
                setVeggies(data);
                // console.log(data);
            }

            setLoading(false);
        };

        fetchVeggies();
    }, []);

    const veggieArr = selectedVeggies.map(item => {
        const match = veggies.find(veggie => veggie.plant_name === item.name);
        return match ? match.id : null;
    }).filter(id => id !== null);

    const displayVeggies = veggies.filter(veggie => veggieArr.includes(veggie.id));

    // Helper function to get count for a veggie
    const getVeggieCount = (veggieName) => {
        if (!veggieCounts || !Array.isArray(veggieCounts)) {
            return 0;
        }
        const veggieCount = veggieCounts.find(item => item.name === veggieName);
        return veggieCount ? veggieCount.count : 0;
    };

    return (
        <div className="plot-planter-garden-veggie-container">
            {displayVeggies.map(veggie => {
                const count = getVeggieCount(veggie.plant_name);
                return (
                    <div
                        key={veggie.id}
                        className={`plot-planter-garden-veggie-card ${count <= 0 ? 'veggie-unavailable' : ''}`}
                    >
                        <div className="plot-planter-garden-veggie-info">
                            <h3>{veggie.plant_name}</h3>
                            <div className="veggie-count">Count: {count}</div>
                            <div className="plot-planter-garden-veggie-dimensions">
                                <div className="plot-planter-garden-veggie-input-group">
                                    <label> W: </label>
                                    <input
                                        type="number"
                                        step="1"
                                        min="1"
                                        max="50"
                                        value={dimensionsByVeggie[veggie.id]?.width ?? veggie.planting_width}
                                        onChange={(e) => {
                                            const value = e.target.value === '' ? '' : Number(e.target.value);
                                            setDimensionsByVeggie(prev => ({
                                                ...prev,
                                                [veggie.id]: {
                                                    width: value,
                                                    height: prev[veggie.id]?.height || veggie.planting_height || 1
                                                }
                                            }));
                                        }}
                                    />
                                    <label> ft </label>
                                </div>

                                <div className="plot-planter-garden-veggie-input-group">
                                    <label> H: </label>
                                    <input
                                        type="number"
                                        step="1"
                                        min="1"
                                        max="50"
                                        value={dimensionsByVeggie[veggie.id]?.height ?? veggie.planting_height}
                                        onChange={(e) => {
                                            const value = e.target.value === '' ? '' : Number(e.target.value);
                                            setDimensionsByVeggie(prev => ({
                                                ...prev,
                                                [veggie.id]: {
                                                    width: prev[veggie.id]?.width || veggie.planting_width || 1,
                                                    height: value
                                                }
                                            }));
                                        }}
                                    />
                                    <label> ft </label>
                                </div>
                            </div>
                        </div>
                        <div className={`plot-planter-veggie-image-circle ${count <= 0 ? 'veggie-unavailable' : ''}`}>
                            <img
                                src={veggie.plant_image_url || fallbackImage}
                                alt={veggie.plant_name}
                                className={`plot-planter-veggie-image ${count <= 0 ? 'veggie-unavailable' : ''}`}
                                draggable={count > 0}
                                onDragStart={(e) => {
                                    if (count <= 0) {
                                        e.preventDefault();
                                        return;
                                    }

                                    const img = e.target;
                                    e.dataTransfer.setDragImage(img, img.width / 2, img.height / 2);

                                    const dims = dimensionsByVeggie[veggie.id] || {
                                        width: veggie.planting_width || 1,
                                        height: veggie.planting_height || 1
                                    };

                                    // Map database properties to expected properties
                                    onVeggieDragStart(e, {
                                        ...veggie,
                                        name: veggie.plant_name,  // Map plant_name to name
                                        image: veggie.plant_image_url || fallbackImage,  // Map plant_image_url to image
                                        veggieImage: veggie.plant_image_url || fallbackImage,  // Also set veggieImage for compatibility
                                        plantingWidth: dims.width,
                                        plantingHeight: dims.height
                                    });
                                }}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PlotPlanterGardenVeggies;